import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LoaderState } from '../models/loader-state';

@Injectable({
  providedIn: 'root',
})
export class ApiLoaderService {
  private loaderStateSubject = new BehaviorSubject<LoaderState>({ show: false });
  loaderState = this.loaderStateSubject.asObservable();

  show() {
    this.loaderStateSubject.next({ show: true });
  }

  hide() {
    this.loaderStateSubject.next({ show: false });
  }
}
